import React from 'react';
import { HiOutlineSun, HiMoon } from 'react-icons/hi';
import { useTheme } from '../context/ThemeContext';
import { cn } from '../lib/cn';
import { Button } from './ui/Button';

export function ThemeToggle({ className }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className={cn('!border-slate-300 !px-2.5 dark:!border-slate-600', className)}
      onClick={toggleTheme}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDark ? <HiOutlineSun className="h-5 w-5" aria-hidden /> : <HiMoon className="h-5 w-5" aria-hidden />}
    </Button>
  );
}
